module.exports = __webpack_public_path__ + "img/preview_fishy_problems.622d1cbf.png";